import { render, staticRenderFns } from "./WealthMoreInvestmentAlternativesBanner.vue?vue&type=template&id=18a64c9b&"
import script from "./WealthMoreInvestmentAlternativesBanner.vue?vue&type=script&lang=ts&"
export * from "./WealthMoreInvestmentAlternativesBanner.vue?vue&type=script&lang=ts&"
import style0 from "./WealthMoreInvestmentAlternativesBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VRow})
